export const mossteamsOverview = {
  heroTitle: 'MossTeams',
  heroSubtitle: '政企级 AI 会议同传解决方案',
  heroTag: 'AI 全场景智能翻译硬件',
  heroDesc: 'MossTeams 是新译科技面向政企单位打造的智能会议同传硬件产品线，涵盖智能会议双屏机、桌面客户端、离线语音盒子三大产品，构建"硬件+软件+算力"全生态协同方案，满足涉密会议、远程协作、多语培训等场景需求。',
  heroImageQuery: 'MossTeams complete product ecosystem display in modern conference room setting, dual screen translation terminal on table next to laptop running desktop client software, compact offline voice computing box nearby, all three MossTeams hardware products together, professional corporate meeting environment, clean minimalist design, warm neutral lighting, blue tech accents',
  heroImageSeq: 'mossteams-overview-hero',
};

export const mossteamsProducts = [
  {
    id: 'dual-screen',
    title: '智能会议双屏机',
    subtitle: '会议室专属 AI 秘书',
    desc: '15.6寸IPS双屏触控，360°全向麦克风+AI降噪，140+语种实时同传，AI速记+会议纪要自动生成，全接口拓展，支持私有化本地部署。',
    features: ['双屏触控', 'AI同传', '离线部署', '多点投屏'],
    href: '/mossteams/dual-screen',
    imageQuery: 'MossTeams dual screen conference translation terminal with two 15.6 inch IPS touch displays on modern meeting table, real time AI simultaneous interpretation with bilingual subtitles visible on both screens, 360 degree omnidirectional microphone array, sleek corporate hardware design, clean product photography, warm neutral workspace lighting, minimalist aesthetic',
    imageSeq: 'mossteams-dual-screen-card',
  },
  {
    id: 'desktop-client',
    title: '桌面客户端',
    subtitle: '会议一体机的桌面搭档',
    desc: '与双屏机无缝联动，构建"硬件+软件"协同体系，凭邀请码入会查看母语字幕、笔记摘录，支持独立创建线上同传会议。',
    features: ['软硬件互通', '远程同传', '要点笔记', '免费基础版'],
    href: '/mossteams/desktop-client',
    imageQuery: 'MossTeams desktop translation client software running on laptop monitor, meeting interface showing real time bilingual subtitles and AI generated meeting notes panel, invitation code entry screen visible, modern clean workspace setup with dual monitors, professional desktop app UI design, warm accent colors, soft office lighting',
    imageSeq: 'mossteams-desktop-card',
  },
  {
    id: 'offline-voice-box',
    title: '离线语音盒子',
    subtitle: '离线 AI 语音算力核心',
    desc: '搭载离线多模态大模型，无网环境独立运行ASR/MT/LLM/TTS全链路，为双屏机、MossVox提供底层翻译算力，主打涉密场景离线部署。',
    features: ['离线全链路', '30+语种', '毫秒响应', '全接口拓展'],
    href: '/mossteams/offline-voice-box',
    imageQuery: 'MossTeams offline voice AI computing box hardware with sleek industrial dark metal design, standalone server grade translation processing unit for secure air gapped environments, NPU chip powered offline ASR MT LLM TTS engine, compact rack mountable device, clean product photography on gradient background, blue LED accent lighting, professional military tech aesthetic',
    imageSeq: 'mossteams-offline-card',
  },
];

export const mossteamsEcosystem = {
  title: '软硬件全生态协同方案',
  subtitle: '双屏机 + 桌面端 + 离线盒子，构建完整的 AI 会议翻译生态闭环',
  desc: 'MossTeams 三大硬件产品深度联动：离线语音盒子提供底层 AI 算力，双屏机作为会议室交互终端，桌面客户端实现远程接入与笔记管理。软硬件一体化设计，满足从涉密离线会议到跨国远程协作的全场景需求。',
  points: [
    { icon: 'ri-computer-line', title: '双屏机', desc: '会议室交互核心，15.6寸双屏触控，360°全向拾音，AI同传+速记一体' },
    { icon: 'ri-hard-drive-2-line', title: '离线盒子', desc: '底层算力引擎，离线多模态大模型，全链路ASR/MT/LLM/TTS独立运行' },
    { icon: 'ri-window-line', title: '桌面端', desc: '远程协作入口，凭码入会查看母语字幕，独立创建同传会议，跨端数据同步' },
  ],
};

export const dualScreenData = {
  banner: {
    title: 'MossTeams 智能会议双屏机',
    subtitle: '会议室专属 AI 秘书',
    tag: '双屏触控 · AI同传 · 离线部署',
    imageQuery: 'MossTeams dual screen AI conference translation terminal closeup in modern meeting room, two 15.6 inch IPS touch displays showing real time Chinese English bilingual simultaneous interpretation subtitles, conference table scene with business professionals in background, sleek corporate hardware design, warm ambient lighting, clean professional product photography',
    imageSeq: 'dual-screen-banner',
  },
  overview: {
    title: '产品概述',
    content: 'MossTeams 智能会议双屏机是一款专为高效会议设计的智能设备，适用于多种会议场景。无论是面对面会议还是远程协作，MossTeams 都能实时转写会议内容并提供即时多语字幕功能，同时自动整理会议纪要，帮助用户高效记录和管理会议信息。MossTeams 通过专业级硬件和 AI 算法，为用户提供高质量的会议体验，满足日常会议、远程协作及跨文化交流的多样化需求。',
    imageSrc: '/images/5b665079fa595fe8db0105a787d3defa.jpeg',
    imageQuery: 'MossTeams dual screen translation device on modern conference table during multinational business meeting, Chinese and foreign executives discussing with real time AI subtitles displayed on both screens, AI generated meeting summary visible on one display, professional corporate boardroom with warm lighting, clean minimalist photography, natural interaction scene',
    imageSeq: 'dual-screen-overview',
  },
  scenarios: {
    title: '适用场景',
    items: [
      {
        icon: 'ri-building-2-line', name: '高校教室', desc: '多语种教学实训，课堂实时字幕辅助，140+语种互译体验',
        imageSrc: '/images/mossteams/dual-screen/9-university-classroom.jpg',
        imageQuery: 'University smart classroom with MossTeams dual screen AI translation device on teacher desk showing multilingual subtitles, foreign language students practicing with real time translation assistance, educational technology in modern academic setting, bright clean interior, warm academic atmosphere, educational photography',
        imageSeq: 'ds-scenario-1',
      },
      {
        icon: 'ri-global-line', name: '跨国企业会议室', desc: '全球团队实时同传协作，打破语言壁垒，提升跨国沟通效率',
        imageSrc: '/images/mossteams/dual-screen/10-multinational-meeting-room.jpg',
        imageQuery: 'International corporate meeting room with MossTeams dual screen translation terminal on table between Chinese and Western executives, real time simultaneous interpretation subtitles visible, global team collaboration scene, modern glass walled conference room, clean professional photography, soft ambient lighting',
        imageSeq: 'ds-scenario-2',
      },
      {
        icon: 'ri-shield-check-line', name: '政企涉密会议', desc: '支持离线私有化部署，数据本地化不外传，满足安全保密需求',
        imageSrc: '/images/mossteams/dual-screen/11-government-confidential-meeting.jpg',
        imageQuery: 'Chinese government classified meeting room with MossTeams dual screen device operating in offline mode, secure private deployment of AI translation hardware, no internet connection symbol visible, professional solemn dark wood paneled interior, confidential atmosphere, clean minimal photography, subdued lighting',
        imageSeq: 'ds-scenario-3',
      },
      {
        icon: 'ri-vidicon-line', name: '跨国远程视频会议', desc: '兼容主流视频会议软件，实时多语字幕投屏，远程无障碍沟通',
        imageSrc: '/images/mossteams/dual-screen/12-remote-video-conference.jpg',
        imageQuery: 'MossTeams dual screen device connected to large display showing international video conference with Zoom interface and multilingual real time subtitles, global team on screen from multiple countries, modern meeting space setup, dual screen casting subtitles to external monitor, clean professional photography, tech ambient lighting',
        imageSeq: 'ds-scenario-4',
      },
    ],
  },
  features: {
    title: '核心功能',
    items: [
      {
        icon: 'ri-file-text-line', name: 'AI 速记', desc: '实时生成会议摘要，自动区分发言人，内容可在线分享、随时查阅，关键信息全程留存。',
        imageSrc: '/images/mossteams/dual-screen/1-ai-notes.jpg',
        imageQuery: 'MossTeams dual screen device one display showing AI generated meeting summary with speaker labels and timestamps, automated meeting minutes and key points extraction, structured notes with action items, productivity tool concept, clean modern interface on 15.6 inch screen, soft warm lighting, professional setting',
        imageSeq: 'ds-feature-1',
      },
      {
        icon: 'ri-translate', name: 'AI 同传', desc: '多语种实时同声传译，支持母语收听；多点字幕投屏，适配全类型会议场景。',
        imageSrc: '/images/mossteams/dual-screen/2-ai-interpretation.jpg',
        imageQuery: 'MossTeams dual screen terminal showing real time simultaneous interpretation with Chinese and English subtitles scrolling on both screens, AI powered speech translation waveform visualization, multiple language options displayed, conference room setting with meeting participants, clean tech interface, soft ambient lighting',
        imageSeq: 'ds-feature-2',
      },
      {
        icon: 'ri-message-2-line', name: 'AI 翻译官', desc: '自动识别语种并实时翻译播报，多样显示模式，实现面对面无障碍交流。',
        imageSrc: '/images/mossteams/dual-screen/3-ai-translator.jpg',
        imageQuery: 'MossTeams dual screen device in conversation translation mode showing split screen bilingual dialogue between Chinese and English speakers, face to face cross language communication scene in office, automatic language detection and real time translation display, friendly business meeting, modern office environment, clean photography, warm lighting',
        imageSeq: 'ds-feature-3',
      },
      {
        icon: 'ri-subtract-line', name: '悬浮字幕', desc: '无遮挡悬浮设计，PPT 讲解、远程会议、线上授课均可快速开启多语字幕。',
        imageSrc: '/images/mossteams/dual-screen/4-floating-subtitles.jpg',
        imageQuery: 'MossTeams dual screen device with floating semitransparent multilingual subtitle overlay during PowerPoint presentation, unobtrusive caption design above slide content, presentation mode with Chinese English translation subtitles, modern conference room with projection screen, clean professional photography, soft lighting',
        imageSeq: 'ds-feature-4',
      },
      {
        icon: 'ri-mic-line', name: 'AI 语音助手', desc: '全语音操控解放双手，支持会中实时问答，依托大模型打造专业企业数字员工。',
        imageSrc: '/images/mossteams/dual-screen/5-ai-voice-assistant.jpg',
        imageQuery: 'MossTeams dual screen device showing AI voice assistant interface with sound wave animation, hands free voice control for meeting queries, digital enterprise assistant powered by large language model, voice command interface on conference table, modern tech design, clean minimal interface, soft blue glow',
        imageSeq: 'ds-feature-5',
      },
      {
        icon: 'ri-cast-line', name: '多点投屏', desc: '多方式、全设备兼容，本地与远程场景均可实现字幕同步投屏。',
        imageSrc: '/images/mossteams/dual-screen/6-multi-screen-casting.jpg',
        imageQuery: 'MossTeams dual screen device wirelessly casting synchronized multilingual subtitles to multiple external displays including laptop monitor and TV screen, multi device screen sharing concept, meeting room with various display devices showing same real time translation captions, modern workspace, clean tech photography, minimalist aesthetic',
        imageSeq: 'ds-feature-6',
      },
      {
        icon: 'ri-link-m', name: '多产品生态', desc: '搭配 Windows/Mac 桌面端可实时摘录笔记；双屏机专属唯一码配置，安全又高效。',
        imageSrc: '/images/mossteams/dual-screen/7-product-ecosystem.jpg',
        imageQuery: 'MossTeams dual screen device on table alongside laptop running MossTeams desktop client with synchronized meeting notes, seamless ecosystem integration between hardware terminal and software client, unique device pairing code displayed, modern conference setup with connected smart devices, clean product photography, soft lighting',
        imageSeq: 'ds-feature-7',
      },
      {
        icon: 'ri-grid-line', name: '跨应用协作', desc: '兼容主流办公软件，跨端协同更顺畅，会后自动输出会议纪要。',
        imageSrc: '/images/mossteams/dual-screen/8-cross-app-collaboration.jpg',
        imageQuery: 'MossTeams dual screen device displaying split screen with Microsoft Office documents and meeting interface, cross platform office software collaboration with translation integration, automatic meeting minutes export to document format, modern productivity workspace, clean design, professional office photography, soft lighting',
        imageSeq: 'ds-feature-8',
      },
    ],
  },
  advantages: {
    title: '产品优势',
    subtitle: '自研 ASR+MT+LLM 三重 AI 引擎，国产化硬件自主可控',
    items: [
      { icon: 'ri-star-line', name: '全场景覆盖', desc: '丰富的软硬件功能，覆盖专业记录、会议纪要、面对面沟通、多语国际会议等全场景' },
      { icon: 'ri-smartphone-line', name: '双屏触控', desc: '15.6寸 IPS 双屏触控、360° 全向麦克风 + AI 降噪、GPU/NPU 硬件算力' },
      { icon: 'ri-usb-line', name: '全接口拓展', desc: 'USB / HDMI / Type-C 全接口拓展，适配各类会议外设与显示设备' },
      { icon: 'ri-global-line', name: '140+ 语种覆盖', desc: '140+ 语种翻译，覆盖 200+ 国家和地区，满足全球化沟通需求' },
      { icon: 'ri-settings-3-line', name: '自定义 AI 词典', desc: '支持自定义行业术语词典、语音唤醒词，适配专业领域翻译需求' },
      { icon: 'ri-shield-check-line', name: '私有化部署', desc: '支持私有化本地部署，数据安全可控，满足军政单位信息安全要求' },
      { icon: 'ri-cpu-line', name: '国产自研', desc: '国产自研 AI 模型，核心硬件国产化自主可控，保障供应链安全' },
    ],
  },
  specs: {
    title: '硬件规格参数',
    rows: [
      { label: '产品型号', value: 'MossTeams D1 / XY-MT01' },
      { label: '屏幕尺寸', value: '15.6 英寸 × 2，IPS 触控屏' },
      { label: '屏幕分辨率', value: '1920 × 1080 (FHD)' },
      { label: '麦克风', value: '360° 全向麦克风阵列 + AI 降噪' },
      { label: '扬声器', value: '双声道立体声扬声器' },
      { label: '处理器', value: '国产自研 NPU + GPU 异构算力' },
      { label: '内存 / 存储', value: '8GB RAM / 128GB ROM' },
      { label: '接口', value: 'USB 3.0 × 2、HDMI × 2、Type-C × 1、3.5mm 音频接口' },
      { label: '网络', value: 'Wi-Fi 6、蓝牙 5.2、千兆以太网口' },
      { label: '电源', value: 'DC 12V / 3A，支持 PoE 供电' },
      { label: '适配系统', value: 'Windows 10/11、macOS 12+' },
      { label: '设备尺寸', value: '380 × 260 × 35 mm（单屏展开）' },
      { label: '设备净重', value: '约 3.8 kg' },
    ],
  },
  related: {
    title: '相关产品推荐',
    items: [
      {
        name: 'MossTeams 桌面客户端',
        desc: '会议一体机的桌面搭档，远程入会同传',
        href: '/mossteams/desktop-client',
        imageSrc: '/images/recommendation/mossteams-desktop-client.jpg',
        imageQuery: 'MossTeams desktop translation client software on laptop showing meeting interface with real time bilingual subtitles and AI notes, complementary software for dual screen hardware, modern workspace setup, clean UI design, professional product screenshot, warm office lighting',
        imageSeq: 'related-desktop-client',
      },
      {
        name: 'MossTeams 离线语音盒子',
        desc: '离线AI算力核心，涉密场景专属',
        href: '/mossteams/offline-voice-box',
        imageSrc: '/images/recommendation/mossteams-offline-voice-box.jpg',
        imageQuery: 'MossTeams offline voice computing box hardware next to dual screen terminal showing secure disconnected network status, offline AI processing unit for classified meetings, dark metal finish compact server device, clean product photography on desk, blue accent LED',
        imageSeq: 'related-offline-box',
      },
    ],
  },
  cta: {
    primary: { text: '在线商务咨询', href: '#consultation' },
    secondary: { text: '下载产品白皮书', href: '/support/downloads' },
    tertiary: { text: '联系采购', href: '/contact' },
    jd: { text: '京东购买', href: 'https://shop.m.jd.com/shop/transition?shopId=13063638&utm_source=pdappwakeupup_20170002' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsam72sbn9gq0bf2e0',
};

export const desktopClientData = {
  banner: {
    title: 'MossTeams 桌面客户端',
    subtitle: '会议一体机的桌面搭档',
    tag: '远程同传 · 软硬件互通 · 永久免费基础版',
    imageSrc: '/images/mossteams/desktop-client/1-banner.jpg',
    imageQuery: 'MossTeams desktop client translation software running on laptop, real time multilingual meeting subtitles displayed in clean interface, AI simultaneous interpretation app for remote conferencing, professional workspace with dual monitors, warm UI design with soft accent colors, clean minimal product photography',
    imageSeq: 'desktop-client-banner',
  },
  overview: {
    title: '产品概述',
    content: 'MossTeams 桌面客户端是新译科技推出的专业会议同传桌面软件，可与 MossTeams 智能会议双屏机无缝联动，构建"硬件 + 软件"协同体系。用户凭会议邀请码入会即可查看母语字幕、实时摘录笔记，也可独立创建线上同传会议，适配企业远程办公场景。支持 Windows 和 macOS 双平台，永久基础版免费使用。',
    imageQuery: 'Professional office worker using MossTeams desktop translation client on laptop monitor during remote video conference, bilingual subtitles visible on screen alongside AI generated meeting notes panel, modern home office setup, clean workspace with natural lighting, collaborative software interface, warm professional environment',
    imageSeq: 'desktop-client-overview',
    imageSrc: '/images/mossteams/desktop-client/2-overview.jpg',
  },
  scenarios: {
    title: '适用场景',
    items: [
      {
        icon: 'ri-vidicon-line', name: '企业远程会议', desc: '跨国团队远程同传协作，实时多语字幕，会后自动生成多语种会议纪要',
        imageQuery: 'Diverse international business team in video conference using MossTeams desktop translation client, real time multilingual subtitles on screen, Zoom meeting interface with AI translation overlay, remote collaboration scene with team members from multiple countries, modern professional photography, clean warm lighting',
        imageSeq: 'dc-scenario-1',
        imageSrc: '/images/mossteams/desktop-client/3-enterprise-remote-meeting.jpg',
      },
      {
        icon: 'ri-graduation-cap-line', name: '跨文化线上培训', desc: '多语种培训课程实时字幕，学员母语查看，知识传递无障碍',
        imageQuery: 'Online cross cultural training session with MossTeams desktop client displaying multilingual subtitles, diverse international learners watching training material in their native language, e-learning platform with real time AI translation captions, modern digital classroom concept, bright clean photography, educational atmosphere',
        imageSeq: 'dc-scenario-2',
        imageSrc: '/images/mossteams/desktop-client/4-cross-cultural-training.jpg',
      },
      {
        icon: 'ri-global-line', name: '跨国线上研讨会', desc: '大型国际研讨会多语种同传字幕，全球参会者母语交互',
        imageQuery: 'Large international webinar with MossTeams desktop translation client providing multilingual simultaneous interpretation subtitles, hundreds of global participants viewing in their native language, presenter on large screen with real time AI translated captions, professional digital event production, clean design, modern tech environment',
        imageSeq: 'dc-scenario-3',
        imageSrc: '/images/mossteams/desktop-client/5-international-webinar.jpg',
      },
    ],
  },
  features: {
    title: '核心功能',
    items: [
      {
        icon: 'ri-login-circle-line', name: '会议接入 / 新建', desc: '凭邀请码一键入会查看母语字幕，也可独立创建同传会议，灵活适配各类会议需求。',
        imageSrc: '/images/mossteams/desktop-client/6-join-create-meeting.jpg',
        imageQuery: 'MossTeams desktop client login interface showing meeting invitation code entry screen, one click join button with multilingual translation option, create new simultaneous interpretation meeting dialog, modern clean app design, minimalist UI with warm accent colors, professional software photography',
        imageSeq: 'dc-feature-1',
      },
      {
        icon: 'ri-translate', name: '多语种识别翻译', desc: '支持 10 种语种识别 + 4 种语种翻译，覆盖主流国际会议语种组合需求。',
        imageSrc: '/images/mossteams/desktop-client/7-multilingual-translation.jpg',
        imageQuery: 'MossTeams desktop client language selection screen showing 10 recognition languages and 4 translation language options, Chinese English Japanese Korean French German Spanish Russian Arabic Portuguese listed, global communication language settings, modern app interface design, clean UI, soft lighting',
        imageSeq: 'dc-feature-2',
      },
      {
        icon: 'ri-sticky-note-line', name: '实时要点笔记', desc: '会议中随时摘录关键信息，自动关联发言人及时间轴，会后一键导出会议纪要。',
        imageSrc: '/images/mossteams/desktop-client/8-realtime-notes.jpg',
        imageQuery: 'MossTeams desktop client note taking feature with meeting transcription and timestamped speaker labels, real time key point extraction during video conference, structured meeting notes with export button, modern productivity tool interface, clean design, soft professional lighting',
        imageSeq: 'dc-feature-3',
      },
      {
        icon: 'ri-cast-line', name: '多设备投屏管控', desc: '支持字幕多设备同步投屏，主讲人可管控投屏内容与显示模式。',
        imageSrc: '/images/mossteams/desktop-client/9-multi-device-casting.jpg',
        imageQuery: 'MossTeams desktop client screen casting control panel showing multiple connected display devices, synchronized multilingual subtitle broadcasting to laptop monitor and external screen, presenter management interface with display mode options, modern presentation setup, clean tech photography',
        imageSeq: 'dc-feature-4',
      },
      {
        icon: 'ri-book-open-line', name: '自定义术语词典', desc: '支持导入行业术语词典，提升专业领域翻译准确率，适配企业个性化需求。',
        imageSrc: '/images/mossteams/desktop-client/10-custom-dictionary.jpg',
        imageQuery: 'MossTeams desktop client custom terminology dictionary management interface, industry specific glossary entries for legal medical technical terms, import custom dictionary feature dialog, professional translation accuracy improvement tool, modern software design, clean UI, professional setting',
        imageSeq: 'dc-feature-5',
      },
    ],
  },
  advantages: {
    title: '产品亮点',
    subtitle: '轻量高效，软硬件生态深度联动',
    items: [
      { icon: 'ri-link-m', name: '软硬件生态互通', desc: '与双屏机、离线盒子无缝联动，构建完整的AI会议翻译生态，数据跨端实时同步' },
      { icon: 'ri-download-cloud-line', name: '轻量化安装', desc: '客户端体积小于200MB，一键安装，自动更新，零运维成本' },
      { icon: 'ri-refresh-line', name: '全端数据同步', desc: '会议纪要、术语词典、个人设置云端同步，换设备无缝衔接' },
      { icon: 'ri-vip-crown-line', name: '永久免费基础版', desc: '基础同传 + 速记功能永久免费，高级功能按需订阅，降低企业使用门槛' },
    ],
  },
  specs: {
    title: '系统要求',
    rows: [
      { label: '适配系统', value: 'Windows 10/11（64位）、macOS 12+（Intel / Apple Silicon）' },
      { label: '最低配置', value: 'CPU: Intel i5 或同等 / 内存: 4GB / 硬盘: 500MB 可用空间' },
      { label: '推荐配置', value: 'CPU: Intel i7 或同等 / 内存: 8GB+ / 硬盘: SSD 1GB 可用空间' },
      { label: '网络要求', value: '宽带网络连接（≥2Mbps），离线功能需搭配离线语音盒子' },
      { label: '语种支持', value: '识别: 10种语种 / 翻译: 4种语种方向（在线模式140+语种）' },
      { label: '安装包大小', value: 'Windows: 约 186MB / macOS: 约 172MB' },
      { label: '版本', value: 'v3.2.0（2025年6月最新版）' },
    ],
  },
  related: {
    title: '相关产品推荐',
    items: [
      {
        name: 'MossTeams 智能会议双屏机',
        desc: '15.6寸双屏触控会议终端',
        href: '/mossteams/dual-screen',
        imageQuery: 'MossTeams dual screen conference translation terminal on modern meeting table, 15.6 inch IPS touch displays showing bilingual subtitles, hardware companion for desktop client, clean product photography, professional setting',
        imageSeq: 'related-dual-screen',
        imageSrc: '/images/recommendation/mossteams-dual-screen.jpg',
      },
      {
        name: 'MossTeams 离线语音盒子',
        desc: '离线AI算力核心，涉密场景专属',
        href: '/mossteams/offline-voice-box',
        imageQuery: 'MossTeams offline voice AI computing box next to laptop running desktop client, secure air gapped translation processing hardware complement, dark metal industrial design, clean product photography',
        imageSeq: 'related-offline-box',
        imageSrc: '/images/recommendation/mossteams-offline-voice-box.jpg',
      },
    ],
  },
  cta: {
    primary: { text: '下载桌面客户端', href: '/support/downloads' },
    secondary: { text: '在线商务咨询', href: '#consultation' },
    tertiary: { text: '联系采购', href: '/contact' },
    jd: { text: '京东购买', href: 'https://shop.m.jd.com/shop/transition?shopId=13063638&utm_source=pdappwakeupup_20170002' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsam72sbn9gq0bf2e0',
};

export const offlineVoiceBoxData = {
  banner: {
    title: 'MossTeams 离线语音盒子',
    subtitle: '离线 AI 语音算力核心',
    tag: '离线全链路 · 数据不联网 · 军工级安全',
    imageSrc: '/images/mossteams/offline-voice-box/1-banner.jpg',
    imageQuery: 'MossTeams offline voice computing box hardware with sleek dark metal industrial design, standalone NPU powered AI translation processing unit for classified military environments, no internet connection required symbol with secure air gap indicator, compact server grade device on clean surface, blue LED accent lighting, premium industrial product photography, military secure tech aesthetic',
    imageSeq: 'offline-box-banner',
  },
  overview: {
    title: '产品概述',
    content: 'MossTeams 离线语音盒子是新译科技自主研发的 AI 语音硬件算力中枢，搭载离线多模态大模型，可在完全无网的环境下独立运行 ASR（语音识别）、MT（机器翻译）、LLM（大语言模型）、TTS（语音合成）全链路引擎。作为 MossTeams 双屏机、MossVox 等产品的底层翻译算力核心，离线语音盒子主打军队、涉密政企、保密科研单位等对数据安全有极高要求的场景，确保翻译全流程数据本地化不联网，满足军工级信息安全标准。',
    imageSrc: '/images/mossteams/offline-voice-box/2-overview.jpg',
    imageQuery: 'MossTeams offline voice computing box installed in secure government server room, NPU AI translation hardware processing unit on rack with Ethernet cable plugged for management only, standalone offline ASR MT LLM TTS engine operational without internet, dark blue ambient server room lighting, modern tech infrastructure, clean professional photography, secure military grade environment',
    imageSeq: 'offline-box-overview',
  },
  scenarios: {
    title: '适用场景',
    items: [
      {
        icon: 'ri-shield-flash-line', name: '军队单位', desc: '完全离线环境运行，数据不外传，满足军事通信安全保密最高等级要求',
        imageSrc: '/images/mossteams/offline-voice-box/3-military-unit.jpg',
        imageQuery: 'MossTeams offline voice computing box in military secure facility server room, completely isolated air gapped environment with no network cables active, classified military operations translation hardware, dark secure bunker style setting, industrial tech equipment, clean professional photography, subdued tactical lighting',
        imageSeq: 'ob-scenario-1',
      },
      {
        icon: 'ri-building-line', name: '涉密政企', desc: '政府机关内部涉密会议，本地化部署，全链路数据不出机关大院',
        imageSrc: '/images/mossteams/offline-voice-box/4-confidential-enterprise.jpg',
        imageQuery: 'MossTeams offline voice box deployed in Chinese government confidential meeting room alongside dual screen terminal, local private deployment in official building, secure translation processing with all data staying within premises, professional solemn wood paneled interior, clean minimal photography',
        imageSeq: 'ob-scenario-2',
      },
      {
        icon: 'ri-lock-line', name: '保密科研单位', desc: '科研机构涉密项目研讨，离线翻译保障知识产权与技术信息安全',
        imageSrc: '/images/mossteams/offline-voice-box/5-confidential-research.jpg',
        imageQuery: 'MossTeams offline voice computing box in classified research laboratory setting, secure AI translation hardware for confidential scientific project discussions, offline operation protecting intellectual property, modern clean lab environment with white surfaces, professional photography, sterile technical atmosphere',
        imageSeq: 'ob-scenario-3',
      },
      {
        icon: 'ri-wifi-off-line', name: '无外网园区', desc: '园区无互联网接入条件下独立运行，毫秒级算力响应，无网络延迟',
        imageSrc: '/images/mossteams/offline-voice-box/6-no-network-campus.jpg',
        imageQuery: 'MossTeams offline voice box operating independently in isolated campus facility without internet access, standalone AI translation processing with sub 500ms response, modern industrial building interior, network disconnected status indicator visible, clean architecture photography, natural daylight through windows',
        imageSeq: 'ob-scenario-4',
      },
    ],
  },
  features: {
    title: '核心功能',
    items: [
      {
        icon: 'ri-cpu-line', name: '全链路多模态处理闭环', desc: '搭载离线ASR/MT/LLM/TTS全链路引擎，语音录入→识别→翻译→合成一体化处理。',
        imageSrc: '/images/mossteams/offline-voice-box/7-full-pipeline.jpg',
        imageQuery: 'MossTeams offline voice computing box visualization of complete AI processing pipeline from speech input through ASR recognition to MT machine translation to LLM large language model to TTS speech synthesis output, integrated offline engine flowchart concept, clean tech diagram style, modern minimal design, soft blue accents',
        imageSeq: 'ob-feature-1',
      },
      {
        icon: 'ri-plug-line', name: '离线引擎独立运行', desc: '无需任何网络连接，离线环境独立运行所有AI翻译功能，数据全程本地化处理。',
        imageSrc: '/images/mossteams/offline-voice-box/8-offline-engine.jpg',
        imageQuery: 'MossTeams offline voice computing box with network cable unplugged showing offline operation mode indicator, completely standalone AI translation processing without internet, disconnected status display on device LED panel, secure local data processing concept, dark ambient setting, clean tech photography',
        imageSeq: 'ob-feature-2',
      },
      {
        icon: 'ri-global-line', name: '30+ 语种识别翻译', desc: '离线支持30+语种语音识别与互译，覆盖主流国际会议及外交场合常用语种。',
        imageSrc: '/images/mossteams/offline-voice-box/9-multilingual.jpg',
        imageQuery: 'MossTeams offline voice box device screen showing 30 plus supported language list for offline translation including Chinese English Japanese Korean French German Spanish Russian Arabic Portuguese, world map with language indicators highlighted, multilingual offline capability concept, clean minimal interface design, soft lighting',
        imageSeq: 'ob-feature-3',
      },
      {
        icon: 'ri-links-line', name: '全系列硬件适配', desc: '即插即用适配 MossTeams 双屏机、MossVox 全系列产品，提供底层统一算力支撑。',
        imageSrc: '/images/mossteams/offline-voice-box/10-hardware-adaptation.jpg',
        imageQuery: 'MossTeams offline voice computing box connected via cables to dual screen conference terminal and MossVox recorder device, plug and play ecosystem integration between computing hub and multiple translation hardware products, central AI processing unit powering various devices, modern tech products arranged on desk, clean product photography, seamless integration concept',
        imageSeq: 'ob-feature-4',
      },
      {
        icon: 'ri-timer-flash-line', name: '毫秒级算力响应', desc: '自研NPU加速芯片 + 轻量化模型蒸馏，语音输入到字幕输出延迟低于500ms。',
        imageSrc: '/images/mossteams/offline-voice-box/11-millisecond-response.jpg',
        imageQuery: 'MossTeams offline voice computing box NPU chip closeup with lightning bolt visualization indicating millisecond processing speed, sub 500ms latency from speech input to subtitle output, high performance edge computing hardware, compact AI accelerator chip detail, clean tech photography, blue LED glow on circuit board',
        imageSeq: 'ob-feature-5',
      },
    ],
  },
  advantages: {
    title: '产品亮点',
    subtitle: '自研国产化硬件，军工级信息安全保障',
    items: [
      { icon: 'ri-usb-line', name: '全接口拓展', desc: 'USB/HDMI/Type-C/千兆以太网口全接口支持，适配各类会议室与机房环境' },
      { icon: 'ri-shield-check-line', name: '数据不联网', desc: '全链路数据本地化处理，无任何外网通信模块，物理隔绝保障信息安全' },
      { icon: 'ri-bar-chart-line', name: '翻译准确率≥90%', desc: '常用语种离线翻译准确率达90%以上，专业领域通过自定义词典进一步提升' },
      { icon: 'ri-settings-3-line', name: '参数自定义配置', desc: '支持语种模型选择、灵敏度调节、术语库导入等参数个性化配置' },
    ],
  },
  specs: {
    title: '硬件规格参数',
    rows: [
      { label: '产品型号', value: 'MossTeams V1 / XY-VB01' },
      { label: '处理器', value: '国产自研 GPU 芯片 + 多核 CPU 异构计算架构' },
      { label: 'AI 算力', value: '≥ 6 TOPS（INT8）' },
      { label: '内存 / 存储', value: '32GB LPDDR5 / 1TB SSD' },
      { label: '离线语种', value: '30+ 语种识别 + 翻译（中/英/日/韩/法/德/西/俄/阿/葡等）' },
      { label: '响应延迟', value: '&lt; 500ms（语音输入 → 字幕输出）' },
      { label: '接口', value: 'USB 3.2 × 4、HDMI 2.1 × 2、Type-C × 2、千兆以太网口 × 1、3.5mm 音频 × 1' },
      { label: '网络', value: '千兆以太网（仅用于管理配置，翻译功能不依赖网络）' },
      { label: '电源', value: 'DC 12V / 5A，支持冗余电源接入' },
      { label: '散热方式', value: '无风扇被动散热设计，零噪音运行' },
      { label: '设备尺寸', value: '220 × 180 × 55 mm' },
      { label: '设备净重', value: '约 2.1 kg' },
      { label: '工作环境', value: '温度 0°C ~ 40°C，湿度 10% ~ 90%（无冷凝）' },
    ],
  },
  related: {
    title: '相关产品推荐',
    items: [
      {
        name: 'MossTeams 智能会议双屏机',
        desc: '搭配离线盒子实现涉密场景完整方案',
        href: '/mossteams/dual-screen',
        imageSrc: '/images/recommendation/mossteams-dual-screen.jpg',
        imageQuery: 'MossTeams dual screen conference terminal connected to offline voice computing box, complete classified meeting translation solution, hardware ecosystem integration, clean product photography on conference table',
        imageSeq: 'related-dual-screen',
      },
      {
        name: 'MossTeams 桌面客户端',
        desc: '远程会议同传，软硬件生态互通',
        href: '/mossteams/desktop-client',
        imageSrc: '/images/recommendation/mossteams-desktop-client.jpg',
        imageQuery: 'MossTeams desktop translation client on laptop with offline voice box providing backend AI computing power, software and hardware ecosystem integration for remote conferencing, clean workspace setup',
        imageSeq: 'related-desktop-client',
      },
    ],
  },
  cta: {
    primary: { text: '在线商务咨询', href: '#consultation' },
    secondary: { text: '下载产品白皮书', href: '/support/downloads' },
    tertiary: { text: '联系采购', href: '/contact' },
    jd: { text: '京东购买', href: 'https://shop.m.jd.com/shop/transition?shopId=13063638&utm_source=pdappwakeupup_20170002' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsam72sbn9gq0bf2e0',
};

export const mossAppData = {
  banner: {
    title: 'MossTeams App',
    subtitle: 'AI 悬浮字幕翻译 · 全平台适配',
    tag: '140+ 语种 · 双向互译 · 悬浮显示 · 全平台覆盖',
    imageSrc: 'https://public.readdy.ai/ai/img_res/dba0a5553cd47e84151ea12ae0995767.jpg',
    imageQuery: 'MossTeams App AI floating translation captions software on laptop screen, semitransparent subtitle bar displaying real time bilingual translation during video conference call, modern digital workspace setup, clean soft warm lighting, professional product screenshot aesthetic',
    imageSeq: 'mossteams-app-banner',
  },
  overview: {
    title: '产品概述',
    content: 'MossTeams App 是一款 AI 悬浮字幕翻译应用，可悬浮于任何应用之上，实时识别语音并翻译成目标语言字幕。深度适配 Zoom、Microsoft Teams、Google Meets、微信语聊、AirPods 通话等所有主流音视频平台，支持 140+ 语种单向及双向互译。无论是跨境视频会议、外语在线课程、跨国亲友通话，悬浮字幕都能让你的每一次对话可听可见。',
    imageSrc: 'https://public.readdy.ai/ai/img_res/e80fa22157fae082790dfc830d361930.jpg',
    imageQuery: 'Person attending international video conference using MossTeams App with floating translation captions visible on laptop screen, bilingual subtitles overlay during meeting with foreign colleagues, modern home office setup with natural lighting, clean minimal workspace, professional work environment photography',
    imageSeq: 'mossteams-app-overview',
  },
  platforms: {
    title: '全平台适配',
    subtitle: '一个应用，覆盖你所有的音视频场景',
    items: [
      { icon: 'ri-video-line', name: 'Zoom', desc: '完美适配Zoom会议，悬浮字幕不影响屏幕共享和参会体验', imageSrc: 'https://public.readdy.ai/ai/img_res/1f8a0a6ed3b8b09dd30393466732bccd.jpg', imageSeq: 'ma-platform-1' },
      { icon: 'ri-team-line', name: 'Microsoft Teams', desc: 'Teams会议自动识别语音，实时双语字幕显示', imageSrc: 'https://public.readdy.ai/ai/img_res/db25a38dc76ea2be3853b320e16fc1d1.jpg', imageSeq: 'ma-platform-2' },
      { icon: 'ri-google-line', name: 'Google Meets', desc: 'Google Meets全功能适配，支持多语种互译', imageSrc: 'https://public.readdy.ai/ai/img_res/3b67f3ec204c48972cdd022c4018042f.jpg', imageSeq: 'ma-platform-3' },
      { icon: 'ri-wechat-line', name: '微信语聊', desc: '微信语音通话、视频通话均可悬浮字幕翻译', imageSrc: 'https://public.readdy.ai/ai/img_res/15065c4460a2cf73d0330ac4ffe6386f.jpg', imageSeq: 'ma-platform-4' },
      { icon: 'ri-headphone-line', name: 'AirPods 通话', desc: 'iPhone通话+AirPods场景，悬浮字幕显示对方说话内容', imageSrc: 'https://public.readdy.ai/ai/img_res/ee5212d31817aef4a5ad4b57abb2cfe2.jpg', imageSeq: 'ma-platform-5' },
      { icon: 'ri-smartphone-line', name: '更多平台', desc: '持续适配更多音视频平台，腾讯会议/钉钉/飞书等均支持', imageSrc: 'https://public.readdy.ai/ai/img_res/d830f0ed48e4749132a5181904b84715.jpg', imageSeq: 'ma-platform-6' },
    ],
  },
  features: {
    title: '核心功能',
    items: [
      { icon: 'ri-subtract-line', name: '悬浮字幕', desc: '半透明悬浮窗始终置顶于任何应用之上，不遮挡关键内容，阅读流畅。', imageSrc: 'https://public.readdy.ai/ai/img_res/84277ca670eda405a866d1e8e1f4d067.jpg', imageSeq: 'ma-feature-1' },
      { icon: 'ri-translate', name: '双向互译', desc: '你说中文对方看英文，对方说英文你看中文，对话自然双向实时翻译。', imageSrc: 'https://public.readdy.ai/ai/img_res/c6f2d15d1a6acf186fe7d6c206a4e0ff.jpg', imageSeq: 'ma-feature-2' },
      { icon: 'ri-global-line', name: '140+ 语种', desc: '覆盖全球主流语言，任意语种之间的单向及双向互译。', imageSrc: 'https://public.readdy.ai/ai/img_res/9a124cef613a9b794419a995c69e9e52.jpg', imageSeq: 'ma-feature-3' },
      { icon: 'ri-font-size', name: '字号可调', desc: '字幕字号、颜色、透明度、显示位置均可自由调节，适配不同视力需求。', imageSrc: 'https://public.readdy.ai/ai/img_res/98fe88a1c1d74cdba0ceb7780e3eef48.jpg', imageSeq: 'ma-feature-4' },
      { icon: 'ri-history-line', name: '字幕记录', desc: '对话记录自动保存为文本文件，会后可回溯查阅，不遗漏关键信息。', imageSrc: 'https://public.readdy.ai/ai/img_res/94b37eaf4772e8d507c7a863729bb5b6.jpg', imageSeq: 'ma-feature-5' },
      { icon: 'ri-download-line', name: '导出字幕', desc: '支持导出为SRT/TXT格式，可用于视频后期字幕制作或会议纪要整理。', imageSrc: 'https://public.readdy.ai/ai/img_res/c741dcf224c110eeeec444d361cc1a4d.jpg', imageSeq: 'ma-feature-6' },
    ],
  },
  scenarios: {
    title: '适用场景',
    items: [
      { icon: 'ri-video-chat-line', name: '跨境视频会议', desc: '跨国会议实时字幕翻译，双语显示确保所有参会者理解一致', imageSrc: 'https://public.readdy.ai/ai/img_res/82adb5ba804ef065bfa3969fe04b6ab6.jpg', imageSeq: 'ma-scenario-1' },
      { icon: 'ri-book-open-line', name: '外语在线课程', desc: 'Coursera/edX等海外课程实时字幕，辅助理解专业术语', imageSrc: 'https://public.readdy.ai/ai/img_res/8330d5c0d3873128fb80b0d9684c4c4b.jpg', imageSeq: 'ma-scenario-2' },
      { icon: 'ri-phone-line', name: '跨国亲友通话', desc: '与海外亲友通话时悬浮显示翻译字幕，亲情交流无障碍', imageSrc: 'https://public.readdy.ai/ai/img_res/45ab7381b6b5e6ca8af7a2204c2f0cb9.jpg', imageSeq: 'ma-scenario-3' },
      { icon: 'ri-live-line', name: '直播翻译', desc: '海外直播/发布会实时字幕，不错过任何精彩内容', imageSrc: 'https://public.readdy.ai/ai/img_res/aa653d813c1006801a3027a08d96d449.jpg', imageSeq: 'ma-scenario-4' },
    ],
  },
  cta: {
    primary: { text: '在线咨询', href: '#consultation' },
    secondary: { text: '下载产品白皮书', href: '/support/downloads' },
    tertiary: { text: '免费体验', href: '/contact' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsjqernpmjsc93fdig',
};
